import register from '../../../../global/js/registry';
export default register('o-teaser-row', () => import(/* webpackMode: "lazy" */ './o-teaser-row.controller'));
